import React from "react";
import { Modal } from "@/components/ui";
import { fmt, fmtDate } from "@/lib/formatters";
import { CreditCard, Wallet, Calendar, Banknote, ShieldCheck } from "lucide-react";

export const ViewReceivedAmountModal = ({ isOpen, onClose, receipt }) => {
  if (!receipt) return null;

  const Card = ({ label, v, fullWidth = false }) => (
    <div className={`bg-slate-50 rounded-lg p-3 ${fullWidth ? 'col-span-2' : ''}`}>
      <div className="text-[10px] text-slate-500 mb-0.5 uppercase font-bold tracking-wider opacity-70">
        {label}
      </div>
      <div className="text-xs font-semibold text-brand-dark">
        {v !== undefined && v !== null && v !== "" ? String(v) : "—"}
      </div>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Receipt Details: #${receipt.receiptId}`} size="max-w-lg">
      <div className="space-y-5">
        <div className="grid grid-cols-2 gap-3">
          <Card label="Project ID" v={receipt.projectId} />
          <Card label="Customer Name" v={receipt.clientName} />
          {receipt.projectName && receipt.projectName !== "—" && (
            <Card label="Project Name" v={receipt.projectName} fullWidth />
          )}

          {receipt.isFollowup ? (
            <>
              <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
                <label className="text-[11px] font-bold text-red-500 uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
                  <Wallet size={14} /> Follow Up Details
                </label>
              </div>
              <Card label="Reason" v={receipt.followupReason} fullWidth />
              <Card label="Approx Payment Date" v={receipt.approxPaymentDate ? fmtDate(receipt.approxPaymentDate) : "—"} />
              <Card label="Follow-up Date" v={receipt.paymentDate ? fmtDate(receipt.paymentDate) : "—"} />
              {receipt.followupDescription && <Card label="Description" v={receipt.followupDescription} fullWidth />}
            </>
          ) : (
            <>
              <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
                <label className="text-[11px] font-bold text-emerald-600 uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
                  <Wallet size={14} /> Payment Details
                </label>
              </div>
              
              <Card label="Amount Received" v={`₹${fmt(receipt.amountReceived)}`} />
              <Card label="Payment Type" v={receipt.paymentStage} />
              <Card label="Payment Date" v={receipt.paymentDate ? fmtDate(receipt.paymentDate) : "—"} />
              <Card label="Payment Mode" v={receipt.paymentMode?.replace(/_/g, " ")} />

              <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
                <label className="text-[11px] font-bold text-brand-blue uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
                  <CreditCard size={14} /> Transaction Info
                </label>
              </div>

              {receipt.transactionId && <Card label="Transaction ID / Ref" v={receipt.transactionId} />}
              {receipt.bankName && <Card label="Bank / Issuing Bank" v={receipt.bankName} />}
              {receipt.branch && <Card label="Branch" v={receipt.branch} />}
              {receipt.upiPhone && <Card label="UPI Phone Number" v={receipt.upiPhone} />}
              {receipt.chequeNumber && <Card label="Cheque Number" v={receipt.chequeNumber} />}
              {receipt.chequeDate && <Card label="Cheque Date" v={receipt.chequeDate} />}
              {receipt.receiverName && <Card label="Receiver Name" v={receipt.receiverName} />}
              {receipt.receiverPhone && <Card label="Receiver Phone" v={receipt.receiverPhone} />}
              
              {receipt.remarks && <Card label="Internal Remarks" v={receipt.remarks} fullWidth />}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
